module.exports = __webpack_public_path__ + "static/img/guide-25.735ac677.png";